/**
 * @generated SignedSource<<4a64c0c7335db10bb2c03c288842d6f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReleaseMaxFilter_query$data = {
  readonly releases: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly releaseKey: string;
        readonly uuid: string;
        readonly versionString: string | null;
      } | null;
    } | null>;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "ReleaseMaxFilter_query";
};
export type ReleaseMaxFilter_query$key = {
  readonly " $data"?: ReleaseMaxFilter_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReleaseMaxFilter_query">;
};

import ReleaseMaxFilterRefetchQuery_graphql from './ReleaseMaxFilterRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "releases"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "deviceTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "maxVersion"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ReleaseMaxFilterRefetchQuery_graphql
    }
  },
  "name": "ReleaseMaxFilter_query",
  "selections": [
    {
      "alias": "releases",
      "args": [
        {
          "kind": "Variable",
          "name": "deviceTypes",
          "variableName": "deviceTypes"
        },
        {
          "kind": "Variable",
          "name": "maxVersion",
          "variableName": "maxVersion"
        },
        {
          "kind": "Literal",
          "name": "versioned",
          "value": true
        }
      ],
      "concreteType": "ReleaseConnection",
      "kind": "LinkedField",
      "name": "__ReleaseMaxFilter_releases_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReleaseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Release",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "versionString",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "releaseKey",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "543ea09e48364c1d3714bf1151d88726";

export default node;
